import type { LayerDef } from "../types";
import { PRICE_RAMP, rampExpression } from "../ramps";

/** Individual recorded sales, shown once you are close enough to read a street. */
export const salesLayer: LayerDef = {
  id: "sales",
  label: "Individual sales",
  group: "prices",
  description:
    "Every recorded flat sale as a dot, coloured by €/m². Visible from street zoom.",
  attribution:
    '<a href="https://www.data.gouv.fr/datasets/demandes-de-valeurs-foncieres-geolocalisees">DVF · DGFiP/Etalab</a>',
  defaultVisible: false,
  usesYear: true,
  sources: {
    sales_points: { type: "vector", url: "pmtiles:///tiles/sales_points.pmtiles" },
  },
  layers: [
    {
      id: "sales-circle",
      type: "circle",
      source: "sales_points",
      "source-layer": "sales",
      minzoom: 12,
      paint: {
        // Grow with zoom so dots stay distinguishable when the street grid does.
        "circle-radius": [
          "interpolate",
          ["linear"],
          ["zoom"],
          12, 2,
          14, 3.5,
          16, 6,
        ] as never,
        "circle-color": rampExpression(PRICE_RAMP, ["get", "price_m2"]) as never,
        "circle-stroke-width": ["interpolate", ["linear"], ["zoom"], 12, 0, 14, 0.8] as never,
        "circle-stroke-color": "#ffffff",
        "circle-opacity": 0.9,
      },
    },
  ],
};
